import type { ComponentPropsWithoutRef } from "react";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import { CodeBlock } from "@/components/storyboard/code/CodeBlock";

const markdownComponents = {
  code: ({
    className,
    children,
    ...rest
  }: ComponentPropsWithoutRef<"code">) => {
    const isBlock = /language-/.test(className ?? "");
    if (!isBlock) {
      return (
        <code className={className} {...rest}>
          {children}
        </code>
      );
    }
    const match = (className ?? "").match(/language-([\w-]+)/);
    const language = match?.[1] ?? "";
    const code = String(children).replace(/\n$/, "");
    return <CodeBlock code={code} defaultLanguage={language} />;
  },
  pre: ({ children }: ComponentPropsWithoutRef<"pre">) => <>{children}</>,
};

/**
 * Renders markdown where every fenced code block is syntax-highlighted via
 * {@link CodeBlock}. Unlike a bare {@link CodeBlock}, this handles content with
 * multiple fences (e.g. a program plus its run command) and mixed languages.
 */
export const CodeMarkdown = ({ children }: { children: string }) => (
  <CourseMarkdown components={markdownComponents}>{children}</CourseMarkdown>
);
